import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.dev';
import { Auth } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AdminUserService {

  private apiUrl = `${environment.apiUrl}/User`;
  private authUrl = `${environment.apiUrl}/auth`;

  constructor(
    private http: HttpClient,
    private auth: Auth
  ) {}

  private getHeaders() {
    const token = this.auth.getToken();
    return { headers: { 'Authorization': `Bearer ${token}` } };
  }

  getUsersByFilters(page: number, size: number, filters: any): Observable<any> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    if (filters.searchTerms) params = params.set('searchTerms', filters.searchTerms);
    if (filters.roleId) params = params.set('roleId', filters.roleId);
    if (filters.isActive !== undefined) params = params.set('isActive', filters.isActive);

    return this.http.get(`${this.apiUrl}/getUsersByFilters`, {
      params,
      ...this.getHeaders()
    });
  }

  createUser(userData: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/createAdminUser`, userData, this.getHeaders());
  }

  deactivateUser(id: number): Observable<any> {
    return this.http.patch(`${this.apiUrl}/deactivateUser/${id}`, {}, this.getHeaders());
  }

  getRoles(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/getRolesAll`, this.getHeaders());
  }

  updateUser(id: number, userData: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/updateUser/${id}`, userData, this.getHeaders());
  }
}